import React, { FC, useMemo } from "react";
import { Button, Table, Tooltip, message, Popover } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { RouterParamType } from "@/model/navModel";
import { DetailType, IServiceNatureCodeType } from "@/types/ScmEnums";
import { IItemDetailList } from "../../maintenanceType";
import { repairFormatNum, formatNum, formatIntPoint } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import useVrmModel from "@/model/vrmModel";
import FontIcon from "@/components/YhIcon";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhBut } from "@/components/YhButton";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { roleColumnModel } from "@/utils/roleColumn";
import moment from "moment";


export const ItemTableBox: FC<RouterParamType> = ({ id, mode, IFormRef }) => {
    const { temporaryObj, setTemporaryid } = useVrmModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const {
        SBcode,
        isThreeService,
        detailAddForm,
        setItemModel,
        detailEditForm,
        detailItemAddList, setDetailItemAddList,
        detailItemAddDataRowKeys, setDetailItemAddDataRowKeys,
        setDetailItemAddDataRow,
        detailItemEditList, setDetailItemEditList,
        detailItemEditDataRowKeys, setDetailItemEditDataRowKeys,
        setDetailItemEditDataRow,
        detailItemLookList,
        detailItemDetailList,
        setTopButsControl,
        recentItems, duplicateItems,
    } = useMaintenanceDetailsModel();
    let { status } = mode === "add" ? detailAddForm : detailEditForm;

    // 计算维修项目的总金额和项数
    const currentItemList = mode === "add" ? detailItemAddList : detailItemEditList;
    const itemTotalAmount = currentItemList.filter((item) => item.threeGuaranteesId == SBcode).reduce((sum, item) => sum + (Number(item.receivableAmount) || 0), 0);
    const itemCount = currentItemList.filter((item) => item.threeGuaranteesId == SBcode).length;

    const onTemporary = () => {
        setTemporaryid(new Date().getTime().toString())
        mode === "add" ? setDetailItemAddList([...detailItemAddList, temporaryObj]) : setDetailItemEditList([...detailItemEditList, temporaryObj])
    }

    const title = <>
        <span>维修项目</span>
        {isThreeService && <span style={{
            color: '#4062d8',           // 辅助文字颜色
            fontSize: '15px',
            fontWeight: '500',
            lineHeight: 1.5,
            marginLeft: '30px',
        }}>总金额
            <span style={{
                color: '#ff615a',        // 金额数字强调色
                fontWeight: 'bold',
                fontSize: '20px',        // 放大金额数字
                margin: '0 6px'       // 与“总金额”稍留间距
            }}>
                ¥ {formatIntPoint(itemTotalAmount)}
            </span>
            元
            ( <span style={{
                color: '#ff615a',        // 项数字同样强调
                fontWeight: 'bold'
            }}>{itemCount}</span> 项 )
        </span>}
    </>
    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && (detailEditForm.status === DictCodeEnmu.MAINTENANCE_COMPLETED || detailEditForm.status === DictCodeEnmu.MAINTENANCE_STATUS_FINAL || detailEditForm.status === DictCodeEnmu.MAINTENANCE_SETTLE || detailEditForm.status === DictCodeEnmu.MAINTENANCE_UNDER_REVIEW || detailEditForm.status === "maintenance-status.paying")) { return false }
        return true;
    }
    const action = <>
        {isMaterialModel() && <>
            <YhAuth resCode={ResourceAuthEnum.M_ED_ADD_I}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={async () => {
                        IFormRef.current?.validateFields().then(async () => {
                            setItemModel(true)
                        })
                    }}
                    disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
                >新增项目</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_DEL_I}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => detailItemDetailList(mode)}
                    disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
                >删除项目</Button>
            </YhAuth>
        </>}
    </>;
    const itemTips = (info: string, visible: boolean) => {
        globalPrompt("modal", {
            title: "新增维修项目",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => { visible && await setItemModel(visible) }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const removeItem = (record: IItemDetailList) => {
        detailItemDetailList(mode, record)
    }
    //已结算 已完工  审核中 审核通过  在修状态下 明细是出库状态的 不可以进行数量编辑
    let numEditable = !!(status !== DictCodeEnmu.MAINTENANCE_STOCK_IO && status !== DictCodeEnmu.MAINTENANCE_COMPLETED && status !== DictCodeEnmu.MAINTENANCE_STATUS_FINAL && status !== DictCodeEnmu.MAINTENANCE_SETTLE && status !== DictCodeEnmu.MAINTENANCE_APPROVED && status !== DictCodeEnmu.MAINTENANCE_UNDER_REVIEW)

    const itemColumn = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '项目编码',
            width: 120,
            dataIndex: 'itemCode',
            render: (text: any) => {
                const duplicate = duplicateItems.find(e => e.itemCode === text);
                const content = "该车（" + moment(duplicate?.createTime).format('YYYY-MM-DD') + "）已进行过相同项目的维修，请检查是否存在相同问题"
                return <Tooltip placement="topLeft" title={text}>
                    <p className="ellipsis">
                        {text}
                        {duplicate &&
                            <Popover placement="right" content={content} trigger="hover">
                                <InfoCircleOutlined style={{ marginLeft: 10, color: '#FAAD14', cursor: 'pointer', verticalAlign: 'baseline', fontSize: 20 }} />
                            </Popover>
                        }
                    </p>
                </Tooltip>
            }
        }, {
            title: '项目名称',
            width: 140,
            dataIndex: 'itemName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '工时',
            width: 100,
            dataIndex: 'workHour',
            editable: isMaterialModel() && numEditable,
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: isMaterialModel(),
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '工时费',
            width: 100,
            dataIndex: 'itemAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            editable: isMaterialModel(),
            render: (text: string) => text + "%"
        }, {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
            editable: isMaterialModel(),
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                isMaterialModel() && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeItem(record)}
                />
        }
    ];

    const typeItemList = {
        "add": [...detailItemAddList],
        "edit": [...detailItemEditList],
        "look": [...detailItemLookList],
    }
    const newSelectItemColums = () =>
        itemColumn.map((col: any, index) => {
            let disaBled = col.dataIndex === "itemCode" || col.dataIndex === "itemName"
            return {
                ...col,
                onCell: (record: IItemDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: disaBled ? record.temporary && mode !== "look" : col?.editable,
                    // editable: disaBled ? record.temporary && mode !== "look" : col.dataIndex === 'workHour' ? (numEditable && record.status !== "details.preparation.ware.out") : col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    // allowClear: col.allowClear,
                    mode: col.mode,
                    handleSave: handleItemSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "order", "roleCodes": roles };
        return getRoleColumns("order", "维修项目", newSelectItemColums(), params);
    }, [roles, typeItemList[mode], itemColumn]);
    const handleItemSave = (row: IItemDetailList) => {
        let { workHour, price, discountRate } = row;
        const newServiceNatureCode = mode === "add" ? detailAddForm.serviceNatureCode : detailEditForm.serviceNatureCode;

        workHour = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(workHour) : +formatNum(workHour); //工时
        price = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(price) : +formatNum(price); //工时费
        discountRate = +formatNum(discountRate);
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%')
        let newRow = {
            ...row,
            price,
            workHour,
            discountRate,
            itemAmount: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(workHour * price) : +formatNum(workHour * price),
            receivableAmount: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((workHour * price * discountRate) / 100) : +formatNum((workHour * price * discountRate) / 100),
        }
        let newData = mode === "edit" ? detailItemEditList : detailItemAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailItemEditList([...newData]) : setDetailItemAddList([...newData])
        setTopButsControl(true)
        recentItems(mode, [...newData]);
    }
    //设置维修项目选中的行和数据
    const setTypeItemDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailItemAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailItemEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeItemDetailDataRow = async (selectedRows: IItemDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailItemAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailItemEditDataRow(selectedRows)
        }
    }

    return (
        <YhBox title={title} rightChildren={action} style={{ marginBottom: "5px", paddingBottom: '5px' }}>
            <Table
                bordered
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={
                    mode === "look" ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detailItemAddDataRowKeys : detailItemEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IItemDetailList[]) => {
                            setTypeItemDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeItemDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeItemDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={isThreeService ? typeItemList[mode].filter((item) => item.threeGuaranteesId == SBcode) : typeItemList[mode]}
                components={components}
                pagination={false}
                scroll={{ x: 'max-content', y: 250 }}
            />
        </YhBox>
    )
}